var idleTime = 0;
var idleInterval = null;
var activateAfter, cart, confirmationText

class TimeoutPopup extends HTMLElement {
  constructor() {
    super()

    activateAfter = Number(this.dataset.activateAfter)
    confirmationText = this.dataset.confirmationText

    this.cart = {
      items: []
    }
  }

  connectedCallback () {
    Shopify.getCart(resp => {
      this.cart = resp
      cart = resp

      if (resp.items.length > 0) {
        idleInterval = setInterval(this.timerInterval, 1000);
      }
    })

    this.initiateIdleTimer()
  }

  initiateIdleTimer () {
    $(document).mousemove(() => {
      idleTime = 0;
    })

    $(document).keypress(() => {
      idleTime = 0;
    })
  }

  timerInterval () {
    idleTime += 1

    if (idleTime >= activateAfter) {
      $('#timeoutPopup').modal('show')

      clearInterval(idleInterval)
    }
  }
}

customElements.define('timeout-popup', TimeoutPopup)
